import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { abstractChart } from '../abstractChart';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  standalone: false,
})
export class BarChartComponent extends abstractChart {
  @Input() label: string = '';
  @Input() color: string = 'rgb(18, 126, 153, .7)';

  @ViewChild('chart') chart: ElementRef<HTMLCanvasElement> | undefined;

  constructor() {
    super('bar', false);
  }

  getLabel(): string {
    return this.label;
  }

  getGraph(): ElementRef<HTMLCanvasElement> | undefined {
    return this.chart;
  }
}
